import { useCallback, useEffect, useRef, useState } from "react";

export const OVERLAY_EXIT_DURATION_MS = 180;

export type RequestExit = (afterExit?: () => void) => void;

export function useExitAnimation(onExit: () => void, duration = OVERLAY_EXIT_DURATION_MS): { exiting: boolean; requestExit: RequestExit } {
  const [exiting, setExiting] = useState(false);
  const exitTimer = useRef<number | null>(null);
  const onExitRef = useRef(onExit);
  onExitRef.current = onExit;

  const requestExit = useCallback<RequestExit>((afterExit) => {
    if (exitTimer.current !== null) return;
    const exitCallback = typeof afterExit === "function" ? afterExit : undefined;
    setExiting(true);
    const reducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    exitTimer.current = window.setTimeout(() => {
      exitTimer.current = null;
      setExiting(false);
      onExitRef.current();
      exitCallback?.();
    }, reducedMotion ? 0 : duration);
  }, [duration]);

  useEffect(() => () => {
    if (exitTimer.current !== null) window.clearTimeout(exitTimer.current);
  }, []);

  return { exiting, requestExit };
}
